// src/routes/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";

export default function ProtectedRoute({ children, roles }) {
  const [ok, setOk] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) { setOk(false); setChecking(false); return; }
      if (!roles || roles.length === 0) { setOk(true); setChecking(false); return; }
      try {
        const snap = await getDoc(doc(db, "users", u.uid));
        const rol = snap.exists() ? (snap.data()?.rol || "") : "";
        setOk(roles.includes(rol));
      } catch {
        setOk(false);
      } finally {
        setChecking(false);
      }
    });
    return () => unsub();
  }, [roles]);

  if (checking) return null; // o un spinner
  return ok ? children : <Navigate to="/" replace />;
}